<template>
  <div>
    <div
      v-for="(val, index) in ideas"
      :key="index"
      class="idea-wrapper"
      @click="ideaModal(val)"
    >
      <p>
        {{lang[0]}}: {{ val.price }}{{lang[1]}}
      </p>
      <p>
        {{lang[2]}}: {{ val.state? lang[6] : lang[5] }}
      </p>
    </div>
    <div v-if="!canSuggestIdea" class="text-center">
      <p>{{lang[3]}}</p>
      <p><a :href="`/account/${$store.state.account.name}`">{{lang[4]}}</a></p>
      <btn size="normal" type="cancel" :label="lang[7]"></btn>
    </div>
    <div v-else class="text-center">
      <btn size="normal" type="primary" :label="lang[7]" @click="sendIdeaModal"></btn>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Btn from '../components/Button.vue'
import RequestSalerPhase0LangMaster from '../masters/langMaster/RequestSalerPhase0LangMaster'

export default {
  name: 'SalerPhase0',

  components:{
    axios,
    Btn
  },

  props:[
     'ideas'
  ],

  data() {
    return {
      lang: RequestSalerPhase0LangMaster[this.$store.state.account.lang],
      canSuggestIdea: false,
    }
  },

  created() {
    this.getAccount()
  },

  methods: {
    ideaModal(val) {
      this.$parent.loading = true
      axios.get(`private/user_id/${val.saler_id}`)
      .then((data) => {
         this.$parent.isIdeaCheck = true
         this.$parent.modalVal = val
         this.$parent.modalUser = data.data.user
         this.$parent.loading = false
      }).catch((err) => {
         console.log(err)
         this.$parent.loading = false
        })
     },

     sendIdeaModal(){
       this.$parent.isSendIdea = true
     },

     getAccount() {
       if(this.$store.state.account.stripe_id) {
         axios.get(`private/stripe/account/${this.$store.state.account.stripe_id}`)
         .then(data => {
           // this.nullCheck(data)
           if(data.data.data.payouts_enabled) {
             this.canSuggestIdea = true
           }
         }).catch(err => {
           console.log(err)
         })
       }
     },
   }
}
</script>

<style scoped>

.idea-wrapper {
  margin: 20px;
  border-radius: 10px;
  background: #F39939;
  padding: 10px;
  color: #fff;
}

.idea-wrapper p {
  margin-bottom: 0.4rem;
}

</style>
